import { client } from "../client";
import type { SavedFile, Document } from "../types/files.types";

export const createFile = async ({
	file,
	fileName,
}: {
	file: File;
	fileName: string | undefined;
}) => {
	const response = await client.postForm<SavedFile>(`files/`, {
		file,
		fileName: fileName,
	});
	return response.data;
};

export const fetchFileContent = async (id: number | string | undefined) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get(`files/download/${id}`, {
		responseType: "arraybuffer",
	});
	return response.data;
};

export const fetchFile = async (id: number | string | undefined | null) => {
	if (id === undefined || id === null) {
		return null;
	}
	const response = await client.get(`files/${id}`);
	return response.data as Document;
};
